export const GET_WEB_TREE_PLAN_SUCCESS = 'GET_WEB_TREE_PLAN_SUCCESS';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const LOADING_MESSAGE = '请稍等...';
